<template>
  <div class="navigate-steps__holder" v-if="windowWidth > 780">
    <div
      class="navigate-steps"
      :style="{
        width: `${circleSize * 1.35}px`,
        height: `${circleSize * 1.35}px`,
      }"
    >
      <div class="navigate-steps__elements">
        <div
          v-for="(step, index) in steps"
          :key="index"
          class="navigate-steps__item"
          :class="[{ 'navigate-steps__item--active': activeStepId === index }]"
          :style="calcTransformShift(index)"
          @click="to(step)"
        >
          <span>{{ $t(`${step}.step`) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from '@/class/Steps';
import Round from '@/class/Round';
import { NavigationDirection } from '@/models/navigation-direction';
import { RoundDirection } from '@/models/round-direction';

export default new Steps({
  methods: {
    calcTransformShift(index) {
      const mr = new Round(this.circleSize * 1.29 / 2, this.steps.length + 5, RoundDirection.LEFT);
      const shift = mr.getCenterShift(index, this.activeStepId);
      return `transform: translate(${shift.x}px, ${shift.y}px);`;
    },
  },
  computed: {
    circleSize() {
      return this.$store.getters.circleSize;
    },
    windowWidth() {
      return this.$store.getters.windowWidth;
    },
  },
}).comp;
</script>

<style lang="scss">
$topBottomGap: 60px;
$stepHeight: 60px;

.navigate-steps__holder {
  position: absolute;
  left: 0%;
  overflow: hidden;
  right: 50%;
  top: 50%;
  height: 100%;
  transform: translate(0%, -50%);
}

.navigate-steps {
  border: 4px solid white;
  border-radius: 50%;

  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(50%, -50%);
}

.navigate-steps__elements {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  justify-content: flex-end;

  position: absolute;
  left: 50%;
  top: calc(50% + #{$stepHeight / 2});
  transform: translate(-100%, -100%);
}

.navigate-steps__item {
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: calc(50% - #{$stepHeight});

  height: $stepHeight;
  line-height: $stepHeight;

  text-align: right;
  font-family: $textFont;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  color: $greenLight;

  cursor: pointer;

  transition: all 200ms ease-in;

  span {
    transition: transform 300ms ease-in;
  }

  &:not(.navigate-steps__item--active) {
    &:hover {
      span {
        transform: translateX(4px);
      }
    }
  }

  &::after {
    content: '';
    width: 14px;
    height: 14px;
    transform: translateX(-1px);

    border: 4px solid white;
    background-color: $green;
    border-radius: 50%;
    margin-left: 5px;

    transition: all 200ms ease-in;
  }
}

.navigate-steps__item--active {
  font-size: 16px;
  color: white;

  &::after {
    width: 30px;
    height: 30px;
    transform: translateX(5px);
  }
}

@media (min-width: 780.89px) {
  .navigate-steps__item {
    font-size: 16px;
  }

  .navigate-steps__item--active {
    font-size: 21px;
  }
}

@media (min-width: 992.89px) {
  .navigate-steps__item {
    font-size: 18px;
    
    &::after {
      width: 20px;
      height: 20px;
      margin-left: 10px;
      transform: translateX(-4px);
    }
  }

  .navigate-steps__item--active {
    font-size: 26px;

    &::after {
      width: 40px;
      height: 40px;
      transform: translateX(6px);
    }
  }
}


</style>
